// Regras de tela da autorização com modelo (AP, ASV). A API decide de verdade; aqui só o que mostrar.

const PREFIX_RE = /^[A-Z]{1,10}$/;

export function emptyTemplateForm(tipoNome = '') {
  return {
    titulo: tipoNome,
    sigla: '',
    proximo_numero: 1,
    validade_dias: 120,
    local: '',
    condicionantesTexto: '',
    assinantes: [{ user_id: '', nome: '', cargo: '' }],
  };
}

export function templateToForm(template, tipoNome = '') {
  if (!template) return emptyTemplateForm(tipoNome);
  return {
    titulo: template.titulo || tipoNome,
    sigla: template.sigla || '',
    proximo_numero: template.proximo_numero ?? 1,
    validade_dias: template.validade_dias ?? 120,
    local: template.local || '',
    condicionantesTexto: (template.condicionantes || []).join('\n'),
    assinantes: (template.assinantes || []).length
      ? template.assinantes.map((s) => ({ user_id: s.user_id, nome: s.nome, cargo: s.cargo }))
      : [{ user_id: '', nome: '', cargo: '' }],
  };
}

export function conditionsFromText(text) {
  return String(text || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function formToTemplate(form) {
  return {
    titulo: String(form.titulo || '').trim(),
    sigla: String(form.sigla || '').trim().toUpperCase(),
    proximo_numero: Number(form.proximo_numero),
    validade_dias: Number(form.validade_dias),
    local: String(form.local || '').trim(),
    condicionantes: conditionsFromText(form.condicionantesTexto),
    assinantes: (form.assinantes || [])
      .map((s) => ({
        user_id: String(s.user_id || '').trim(),
        nome: String(s.nome || '').trim(),
        cargo: String(s.cargo || '').trim(),
      }))
      .filter((s) => s.user_id || s.nome || s.cargo),
  };
}

/** Primeiro problema do formulário, ou null. Espelha a validação da API para avisar antes de enviar. */
export function templateFormError(form) {
  const t = formToTemplate(form);
  if (!t.titulo) return 'Informe o título do documento.';
  if (!PREFIX_RE.test(t.sigla)) return 'A sigla deve ter de 1 a 10 letras (ex.: AP, ASV).';
  if (!Number.isInteger(t.proximo_numero) || t.proximo_numero < 1) return 'O próximo número deve ser 1 ou maior.';
  if (!Number.isInteger(t.validade_dias) || t.validade_dias < 1) return 'A validade deve ter pelo menos 1 dia.';
  if (!t.assinantes.length) return 'Indique pelo menos um assinante.';
  if (t.assinantes.some((s) => !s.user_id || !s.nome || !s.cargo)) {
    return 'Cada assinante precisa de usuário, nome e cargo.';
  }
  if (new Set(t.assinantes.map((s) => s.user_id)).size !== t.assinantes.length) {
    return 'O mesmo usuário aparece duas vezes entre os assinantes.';
  }
  return null;
}

export function authorizationStatus(row) {
  if (row?.numero) return { id: 'emitida', label: 'Emitida', tone: 'success' };
  if ((row?.assinaturas || []).length) return { id: 'assinando', label: 'Aguardando assinaturas', tone: 'warning' };
  return { id: 'rascunho', label: 'Rascunho', tone: 'neutral' };
}

export function canEditAuthorization(row) {
  return !row?.numero && !(row?.assinaturas || []).length;
}

export function pendingSigners(row, template) {
  const signed = new Set((row?.assinaturas || []).map((s) => s.user_id));
  return (template?.assinantes || []).filter((s) => !signed.has(s.user_id));
}

export function canSignAuthorization(row, template, userId) {
  if (!row || row.numero || !userId) return false;
  return pendingSigners(row, template).some((s) => s.user_id === userId);
}

export function isTotpRequired(error) {
  return error?.response?.data?.detail?.code === 'TOTP_REQUIRED';
}

export function validationSituation(result) {
  if (!result) return null;
  return result.situacao === 'valida'
    ? { label: 'Documento válido', tone: 'success' }
    : { label: 'Documento vencido', tone: 'warning' };
}

export function normalizeVerificationCode(code) {
  return String(code || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}
